module.exports = __webpack_public_path__ + "img/Reynolds.efa3e511.jpg";